import glamorous from 'glamorous'
import { COLORS } from 'config'

const RadioCircle = glamorous.div(({ isChecked }) => ({
  boxSizing: 'border-box',
  position: 'relative',
  width: 24,
  height: 24,
  marginRight: 8,
  borderRadius: '50%',
  borderWidth: 2,
  borderStyle: 'solid',
  borderColor: COLORS.blue,
  '::after': {
    content: isChecked ? '""' : null,
    position: 'absolute',
    top: 2,
    left: 2,
    width: 16,
    height: 16,
    borderRadius: '50%',
    backgroundColor: COLORS.blue
  }
}))

export default RadioCircle



// WEBPACK FOOTER //
// ./src/components/settings/RadioCircle.js